import classnames from 'classnames'
import React from 'react'
import { Link } from 'react-router-dom'

import useRoutes from '../../state/useRoutes'
import UserRoleIcon from '../UserRoleIcon/UserRoleIcon'

import styles from './UserAvatar.module.scss'
import { UserProperties } from '../../models/BaseModels'

type AvatarProps = {
  user: UserProperties
  omitRoleIcon?: boolean
  link?: boolean
  large?: boolean
} & React.ComponentPropsWithoutRef<'div'>

export default React.memo(function UserAvatar({
  user,
  omitRoleIcon,
  link,
  large,
  className,
  ...htmlProps
}: AvatarProps) {
  const routes = useRoutes()

  const src: { src?: string } = {}
  if (user.avatarUrl) {
    src.src = user.avatarUrl
    // FIXME: This is very brittle. The user should provide its own thumbnail URL.
    if (!large && src.src.match(/\/api\/user\/.*?\/image/)) {
      src.src = src.src.replace('/image', '/image-thumbnail')
    }
  }

  const initials = user.isAnonymous
    ? '?'
    : `${(user.firstname[0] || '').toUpperCase()}${(user.lastname[0] || '').toUpperCase()}`

  const Component = link && !user.isAnonymous && user.role !== 'trainer' ? Link : 'div'

  return (
    <Component
      className={classnames(styles.Avatar, className, {
        skeleton: user.isDummy,
        [styles.inactive]: user.status !== 'active',
      })}
      {...(htmlProps as any)}
      to={link ? routes.manageUser.url({ uuid: user.uuid }) : undefined}
    >
      <img alt={`${user.firstname} ${user.lastname}`} data-initials={initials} {...src} />
      {!omitRoleIcon && <UserRoleIcon userRole={user.role} userStatus={user.status} className={styles.roleIcon} />}
    </Component>
  )
})
